export const PlanSelectionConfigMock = {
  getLocationBasedMessages: true,
  getDynamicMessages: {
    zipcodeMarketing: false,
    zidecodeCountyMarketing: true,
  },
  showPlanDetails: true,
  shoppingCart: {
    totalPremiumLabel: 'Total Premium:',
  },
  singlePlanType: 'medical',
  showShoppingCart: true,
  setTabAsPerSubsidyAmount: true,
  quoting: true,
  compare_plans: {
    displayDocuments: [
      {
        type: 'summary_of_benefits',
        label: 'Summary of Benefits',
      },
      {
        type: 'evidence_of_coverage',
        label: 'Evidence of Coverage',
      },
      {
        type: 'drug_formulary',
        label: 'Drug Formulary',
      },
      {
        type: 'find_a_clinic_or_hospital',
        label: 'Find a Clinic or Hospital',
      },
    ],
    showNavigation: true,
    premiumSuffix: 'per month',
    comparePlaceholder: 'add plan to compare',
    compareMessage: 'Select up to ${maxComparable} plans to compare',
    compareTitle: 'Compare',
    label: {
      backToPlans: 'Back to All Plans',
      linkLabel: 'Click Here',
    },
    enrollButton: 'Enroll',
    planKeysToShowForBenefits: [
      {
        labelToSearchForInBenefits: 'out of pocket',
        planKey: 'max_out_of_pocket',
        label: 'Individual Max Out Of Pocket',
        value: '',
        type: 'plan',
        format: 'CURRENCY',
      },
      {
        labelToSearchForInBenefits: 'family out of pocket',
        planKey: 'max_out_of_pocket_family',
        label: 'Family Max Out Of Pocket',
        value: '',
        type: 'plan',
        format: 'CURRENCY',
      },
      {
        labelToSearchForInBenefits: 'deductible',
        planKey: 'deductible',
        label: 'Individual Deductible',
        value: '',
        type: 'plan',
        format: 'CURRENCY',
      },
      {
        labelToSearchForInBenefits: 'family deductible',
        planKey: 'deductible_family',
        label: 'Family Deductible',
        value: '',
        type: 'plan',
        format: 'CURRENCY',
      },
    ],
    showSiteFooter: false,
    headerCardType: 'RoundedCorner',
    showEnroll: false,
    text: {
      benefits: 'Benefits',
      all: 'All',
      monthly_premium: 'Monthy Premium',
      back_to_plans: 'Back to All Plans',
    },
  },
  multi_plan_selection: {
    text: {
      no_results: 'NO RESULTS',
      you_selected_multi: "You've selected multiple plans.",
      you_selected: "You've Selected:",
    },
  },
  singlePlanSelection: {
    plan_details: {
      displayAllDocuments: true,
      find_doctor: {
        label: 'Find a Doctor',
        link: null,
      },
      summary_benefits: {
        label: 'View Summary of Plan Benefits',
      },
      omnia_note:
        'Note: You are viewing OMNIA Tier 1 benefits. You doctor must be in this network to receive this benefit.',
      showLinks: false,
    },
    text: {
      headerSubtitle: null,
      youSelected: "You've selected ",
      noResults: 'NO RESULTS',
    },
  },
  button: {
    content: 'Review Quote',
  },
  showCompare: true,
  showFilters: true,
  filters: {
    filterApplyButton: 'Apply',
    sortHeader: 'Sort',
    filterHeader: 'Filters',
    filterResetButton: 'Reset',
    controls: [
      {
        type: 'radio',
        label: 'Sort by',
        options: [
          {
            value: 'price',
            label: 'Lowest Monthly Premium',
          },
        ],
        prop: 'ordering',
        customFormElement: false,
        ariaLabel: 'Sort by',
      },
      {
        type: 'radio',
        label: 'Monthly Premium',
        options: [
          {
            value: {
              price_low: 0,
              price_high: 500,
            },
            label: 'Under $500',
          },
        ],
        prop: 'price',
        customFormElement: false,
        ariaLabel: 'Monthly Premium',
      },
      {
        type: 'radio',
        label: 'Deductible',
        options: [
          {
            value: {
              deductible_low: 0,
              deductible_high: 1000,
            },
            label: 'Under $1000',
          },
        ],
        prop: 'deductible',
        customFormElement: false,
        ariaLabel: 'Deductible',
      },
    ],
  },
  disabledTooltipText: 'The maximum amount of plans have been selected',
  hideStandaloneDental: true,
  noModal: true,
  label: 'Plan Selection',
  type: 'plan-selection',
  maxSelectable: 4,
  canCompare: false,
  onExchange: 'true',
  shoppingHeaderOverrides: {
    medical: {
      title: 'Plans Available In Your ZIP Code',
      subtitle: '',
    },
    subsidy: {
      title: 'Marketplace Plans',
      subtitle: '',
    },
  },
  planTypes: [
    {
      prop: 'medical',
      label: 'Plans without Subsidies',
      subProp: 'not-subsidy',
    },
    {
      prop: 'medical',
      label: 'Plans with Subsidies',
      subProp: 'subsidy',
    },
  ],
  planTabLabels: [
    {
      prop: 'medical',
      text: 'Plans without Subsidies',
      subProp: 'not-subsidy',
      pill: 7,
    },
    {
      prop: 'medical',
      text: 'Plans with Subsidies',
      subProp: 'subsidy',
      pill: 3,
    },
  ],
  deleteConfirmModal: {
    header: 'Delete Plan?',
    body: 'You are about to delete ${display_name}',
    confirm: 'Yes, Delete Plan',
  },
  review: [
    {
      type: 'planCard',
      label: 'Product/Plan Selection',
    },
  ],
  extraPlanFilters: {
    market_segment: 'individual',
  },
  showNewCard: false,
  subsidyText: {
    subsidyLabel: 'with a ${subsidyAmount} subsidy',
    originalPriceLabel: '(Originally ${originalPrice})',
  },
  footerNextButtonDisplayText: {
    vision: 'Review Quote',
    medical: 'Review Quote',
    'health/dental': 'Next',
    health: 'Review Quote',
    'medical/dental': 'Next',
    'dental/vision': 'Review Quote',
    bundled: 'Review Quote',
    dental: 'Review Quote',
  },
  planKeysToShowForBenefits: [
    {
      labelToSearchForInBenefits: 'out of pocket',
      planKey: 'max_out_of_pocket',
      label: 'Individual Max Out Of Pocket',
      value: '',
      type: 'plan',
      format: 'CURRENCY',
    },
    {
      labelToSearchForInBenefits: 'family out of pocket',
      planKey: 'max_out_of_pocket_family',
      label: 'Family Max Out Of Pocket',
      value: '',
      type: 'plan',
      format: 'CURRENCY',
    },
    {
      labelToSearchForInBenefits: 'deductible',
      planKey: 'deductible',
      label: 'Individual Deductible',
      value: '',
      type: 'plan',
      format: 'CURRENCY',
    },
    {
      labelToSearchForInBenefits: 'family deductible',
      planKey: 'deductible_family',
      label: 'Family Deductible',
      value: '',
      type: 'plan',
      format: 'CURRENCY',
    },
  ],
  headerCardType: 'RoundedCorner',
  isAccordionOpen: false,
};

export const ComparePlansConfigMock = {
  showSiteFooter: false,
  showEnroll: false,
  showStarRating: true,
  text: {
    benefits: 'Benefits',
    all: 'All',
    monthly_premium: 'Monthly Premium',
    back_to_plans: 'Back to All Plans',
  },
  showFooter: true,
  displayAllDocuments: true,
  displayDocuments: [
    {
      type: 'summary_of_benefits',
      label: 'Summary of Benefits',
    },
    {
      type: 'evidence_of_coverage',
      label: 'Evidence of Coverage',
    },
    {
      type: 'drug_formulary',
      label: 'Drug Formulary',
    },
    {
      type: 'find_a_clinic_or_hospital',
      label: 'Find a Clinic or Hospital',
    },
    {
      type: 'find_a_pharmacy',
      label: 'Find a Pharmacy',
    },
    {
      type: 'find_a_doctor',
      label: 'Find a Doctor',
    },
    {
      type: 'search_provider',
      label: 'Search Provider',
    },
    {
      type: 'search_facility',
      label: 'Search Facility',
    },
    {
      type: 'search_pharmacy',
      label: 'Search Pharmacy',
    },
  ],
};

export const PlansMock = [
  {
    id: 1033,
    hios_ids: null,
    year: 2023,
    percent_of_premium: '',
    deductible: 0,
    deductible_family: 0,
    max_out_of_pocket: 6000,
    max_out_of_pocket_family: 0,
    price: 0,
    static_price: 0,
    premium: null,
    star_rating: null,
    external_id: 'H2459020000',
    plan_type: 'mapd',
    metal_tier: '',
    market_segment: 'medicare',
    display_name: 'UCare Prime (HMO-POS)',
    plan_variation: null,
    exchange_type: null,
    hsa: false,
    county: {
      county_name: 'Wilkin',
      county_code: '24830',
    },
    plan_codes: [],
    documents: {
      drug_formulary: {
        document_id:
          'https://www.ucare.org/search-network/formulary/2023/medicare/prime',
        type: 'drug_formulary',
      },
      evidence_of_coverage: {
        document_id:
          'https://media.ucare.org/-/media/documents/public/plan-documents/2023/eocs/u7984_ucaremedicare-prime_eoc_2023.pdf',
        type: 'evidence_of_coverage',
      },
      summary_of_benefits: {
        document_id:
          'https://media.ucare.org/-/media/documents/public/plan-documents/2023/sbs/u8056_medicare-north_sb_2023.pdf',
        type: 'summary_of_benefits',
      },
      find_a_clinic_or_hospital: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=facility&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_clinic_or_hospital',
      },
      find_a_pharmacy: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=pharmacy&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_pharmacy',
      },
      find_a_doctor: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=provider&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_doctor',
      },
    },
    member_prices: {},
    benefits: [
      {
        label: 'Part D Tiers: Tier 4',
        value: '50% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'X-Ray Services',
        value: '20% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Routine Hearing Exams',
        value: '$0 Copay: Limit to 1 exam every year',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Hearing Aid (all types)',
        value:
          "$699 Copay, $999 Copay: Quantity for Hearing Aids (all types): 2 every year. Coverage is limited to TruHearing's Advanced and  Premium hearing aids. Minimum copay applies to the Advanced hearing aid and the maximum copay applies to the Premium hearing aid",
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Durable Medical Equipment (DME)',
        value: '20% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Supplemental Preventive Dental',
        value:
          '$400 Yearly Allowance: Combined Allowance for Preventive Dental',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Vision - Diagnostic',
        value: '$50 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'OTC items',
        value: '$75 Allowance: Every 6 months (Store, Mail, Online)',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Lab Services',
        value: '$0 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Hearing - Diagnostic Medicare Covered',
        value: '$50 Copay: Limit to 3 Every Year',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Annual Physical Exam',
        value: '$0 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Part D Tiers: Tier 3',
        value: '17% Coinsurance, 25% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Deductible',
        value: '$480',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Eyewear (frames and lenses)',
        value: '$100 Allowance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Part D Tiers: Tier 5',
        value: '25% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Urgent Care',
        value: '$45 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Part D Tiers: Tier 2',
        value: '$10 Copay, $20 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Skilled Nursing Facility (SNF)',
        value: '$0 Copay Per Day (Days 1-20), $196 Copay Per Day (Days 21-100)',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Outpatient Hospital Services',
        value: '$425 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Part D Tiers: Tier 1',
        value: '$3 Copay, $12 Copay: Tier 1 is excluded from the deductible',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Fitness benefit',
        value: '$0 One Pass, $30 Credit: One Pass or the credit',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Routine Eye Exams',
        value: '$0 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Diagnostic Procedures/Tests',
        value: '20% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Inpatient Hospital - Acute',
        value: '$350 Copay Per Day (Days 1-5), $0 Copay Per Day (Days 6-90)',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Worldwide Urgent Coverage',
        value:
          '$100 Copay: The worldwide emergency transportation benefit includes ground ambulance to the nearest appropriate hospital for emergency care.',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Ground Ambulance Services',
        value: '$300 Copay',
        type: null,
        benefit_display_index: null,
      },
    ],
    primary_benefits: [
      {
        label: 'Telehealth: Primary Care Physician Services',
        value: '$25 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Primary Care Physician Services',
        value: '$25 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Telehealth: Physician Specialist Services',
        value: '$50 Copay',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Worldwide Emergency Coverage',
        value:
          '$100 Copay: The worldwide emergency transportation benefit includes ground ambulance to the nearest appropriate hospital for emergency care.',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'Physician Specialist Services',
        value: '$50 Copay',
        type: null,
        benefit_display_index: null,
      },
    ],
    add_ons: [],
    links: [],
    hmo: null,
    internal_name: null,
    is_active: true,
    is_benchmark: false,
    is_catastrophic: false,
    is_auto_bundle: false,
    network_codes: ['RIRI23'],
    networks: [
      {
        network_code: 'RIRI23',
        name: '2023 Medicare Plans',
        year: 2023,
      },
    ],
    rating_region: {
      region_name: 'NMN_32C',
      plan_year: 2023,
    },
    primary_care: '',
    generic_rx: '',
    plan_marketing_description:
      'Basic coverage with higher out-of-pocket costs',
    selected: false,
    comparing: true,
    index: 0,
    formattedBenefits: [
      {
        label: 'Part D Tiers: Tier 4',
        value: '50% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
      {
        label: 'X-Ray Services',
        value: '20% Coinsurance',
        type: null,
        benefit_display_index: null,
      },
    ],
    allBenefitsLink: 'https://www.google.com/',
  },
  {
    id: 1027,
    hios_ids: null,
    year: 2023,
    percent_of_premium: '',
    deductible: 0,
    deductible_family: 0,
    max_out_of_pocket: 5400,
    max_out_of_pocket_family: 0,
    price: 24,
    static_price: 24,
    premium: null,
    star_rating: null,
    external_id: 'H2459029000',
    plan_type: 'mapd',
    metal_tier: '',
    market_segment: 'medicare',
    display_name: 'UCare Aware (HMO-POS)',
    plan_variation: null,
    exchange_type: null,
    hsa: false,
    county: {
      county_name: 'Wilkin',
      county_code: '24830',
    },
    plan_codes: [],
    documents: {
      drug_formulary: {
        document_id:
          'https://www.ucare.org/search-network/formulary/2023/medicare/aware',
        type: 'drug_formulary',
      },
      evidence_of_coverage: {
        document_id:
          'https://media.ucare.org/-/media/documents/public/plan-documents/2023/eocs/u9841_ucaremedicare-aware_eoc_2023.pdf',
        type: 'evidence_of_coverage',
      },
      summary_of_benefits: {
        document_id:
          'https://media.ucare.org/-/media/documents/public/plan-documents/2023/sbs/u8056_medicare-north_sb_2023.pdf',
        type: 'summary_of_benefits',
      },
      find_a_clinic_or_hospital: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=facility&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_clinic_or_hospital',
      },
      find_a_pharmacy: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=pharmacy&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_pharmacy',
      },
      find_a_doctor: {
        document_id:
          'https://search.ucare.org/provider-search/results?entity_type=provider&distance=60&latitude=46.8009266&longitude=-96.7532792&network_code=RIRI23',
        type: 'find_a_doctor',
      },
    },
    member_prices: {},
    benefits: [],
    primary_benefits: [],
    add_ons: [],
    links: [],
    hmo: null,
    internal_name: null,
    is_active: true,
    is_benchmark: false,
    is_catastrophic: false,
    is_auto_bundle: false,
    network_codes: ['RIRI23'],
    networks: [
      {
        network_code: 'RIRI23',
        name: '2023 Medicare Plans',
        year: 2023,
      },
    ],
    rating_region: {
      region_name: 'NMN_32C',
      plan_year: 2023,
    },
    primary_care: '',
    generic_rx: '',
    plan_marketing_description:
      'Basic coverage for a low monthly cost and affordable copays',
    selected: false,
    comparing: true,
    index: 1,
    formattedBenefits: [],
    allBenefitsLink: 'https://www.google.com/',
  },
];

export const AllBenefitsMock = [
  {
    label: 'Telehealth: Primary Care Physician Services',
    value: '$25 Copay',
    type: null,
    benefit_display_index: null,
  },
  {
    label: 'Primary Care Physician Services',
    value: '$25 Copay',
    type: null,
    benefit_display_index: null,
  },
];

export const PrimaryBenefitsMock = [
  {
    label: 'Urgent care visit',
    value: '$20 ',
    type: null,
    benefit_display_index: null,
  },
  {
    label: 'Primary care visit',
    value: '$25 ',
    type: null,
    benefit_display_index: null,
  },
];

export const BenefitMock = [
  {
    labelToSearchForInBenefits: 'out of pocket',
    planKey: 'max_out_of_pocket',
    label: 'Individual Max Out Of Pocket',
    value: '',
    type: 'plan',
    format: 'CURRENCY',
  },
];

export const mockActivatedRoute = {
  snapshot: {
    data: {
      pageName: 'plan-selection',
    },
  },
};
